import dayjs, { Dayjs } from 'dayjs';
import { DateType } from './const';

export function formatDuration(ms: number) {
  if (ms <= 0) return '0分';

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;

  const days = Math.floor(ms / day);
  const hours = Math.floor((ms % day) / hour);
  const minutes = Math.floor((ms % hour) / minute);

  let str = '';

  if (days > 0) str += `${days}天`;
  if (hours > 0) str += `${hours}时`;

  // 分钟必须显示（允许是 0）
  str += `${minutes}分`;

  return str;
}

/**
 * 获取默认时间
 */
export const getDefaultTime = (mode: DateType, date?: Dayjs | null) => {
  switch (mode) {
    case DateType.DAY:
      return {
        startTime: dayjs(date).startOf('day').valueOf(),
        endTime: dayjs(date).endOf('day').valueOf(),
      };
    case DateType.WEEK:
      return {
        startTime: dayjs(date).startOf('week').valueOf(),
        endTime: dayjs(date).endOf('week').valueOf(),
      };
    case DateType.MONTH:
      return {
        startTime: dayjs(date).startOf('month').valueOf(),
        endTime: dayjs(date).endOf('month').valueOf(),
      };

    default:
      return {
        startTime: dayjs(date).valueOf(),
        endTime: dayjs(date).valueOf(),
      };
  }
};
